import React from "react";
import { useLoaderData } from "react-router-dom";
import { TitledContent } from "./TitledContent";
import { FormattedMessage } from "react-intl";
import UserAliasesTable from "./UserAliasesTable";
import { fetchList, ListRequest } from "../utils/crud";
import { FetchFunction } from "./FetchProvider";

export async function accountAliasesLoader(fetch: FetchFunction, userId: number) {
    const req = new ListRequest("user_alias", {
        filters: {
            operator: "==",
            column: "user_id",
            value: userId,
        },
    });

    const result = await fetchList(fetch, req);

    return result ? result.rows : [];
}

const AccountAliasesPage: React.FC = () => {
    const rows: any = useLoaderData();

    return (
        <TitledContent title={<FormattedMessage id="user_alias.list" defaultMessage="Login names" />}>
            <UserAliasesTable rows={rows} showDeleteButton={false} />
        </TitledContent>
    );
};

export default AccountAliasesPage;
